/*
 * Every configure card (seats, agent packs, order summary) renders one of
 * these, so all of them follow the same pattern: skeleton on `pageLoading`,
 * price skeletons over resolved content on `priceLoading`, full content on
 * `ready`. Cards branch on `status.type` rather than null-checking props.
 *
 * `priceLoading` carries `data` on purpose. A card whose structure has resolved
 * stays populated while its prices re-fetch, which is what keeps a stepper
 * click from collapsing the whole card back to a skeleton.
 */

/*
 * Derives one card's status from that card's own data and its own price query.
 * Callers must pass only the queries the card actually reads — projecting a
 * page-wide loading flag through here is what couples unrelated cards together
 * and makes them skeleton in lockstep.
 */
export const buildFscCardStatus = ({
  data,
  isPriceLoading
}) => {
  if (!data) {
    return {
      type: 'pageLoading'
    };
  }
  return isPriceLoading ? {
    type: 'priceLoading',
    data
  } : {
    type: 'ready',
    data
  };
};